import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { ChargeAccountBaseComponent } from '../charge-account-base.component';
import { UserService } from 'src/app/angularJS/services/user/user.service';

/**
 * Class containing properties and methods for displaying product usage on a charge account
 */
export class ChargeAccountProductsController extends ChargeAccountBaseComponent {
  public static $inject = [
    'chargeAccount',
    'breadcrumbService',
    'customerService',
    'ACTToolbarService',
    'userService',
    '$state',
    '$translate',
    '$stateParams'
  ];
  public parentUsageEventProductMappingId: string;
  public events = {
    onUsageEventProductMappingIdUpdated: undefined
  };
  public selectedSubTab = 0;
  public customer: InterACT.Interfaces.Customers.Customer;

  constructor(
    public chargeAccount: InterACT.Interfaces.ChargeAccounts.ChargeAccount,
    public breadcrumbService: BreadcrumbService,
    public customerService: CustomerService,
    public ACTToolbarService: ACTToolbarService,
    public userService: UserService,
    public $state: ng.ui.IStateService,
    public $translate: ng.translate.ITranslateService,
    private $stateParams,
  ) {
    super(chargeAccount, breadcrumbService, customerService, ACTToolbarService, userService, $state, $translate);
    this.activate();
  }

  /**
   * A method that gets fired when a new replacement product has been selected on the UI
   */
  public onNewReplacementProductSelected = (replacementUsageEventProductMappingId: string) => {
    this.parentUsageEventProductMappingId = replacementUsageEventProductMappingId;

    if (this.events.onUsageEventProductMappingIdUpdated) {
      this.events.onUsageEventProductMappingIdUpdated(replacementUsageEventProductMappingId);
    }
  }

  /**
   * A method that is called during instantiation of the controller to set up its data
   */
  private activate() {
    this.parentUsageEventProductMappingId = this.$stateParams.parentUsageEventProductMappingId;
    this.setToolbarAndBreadcrumbs('charge-account-products');
  }
}